import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import supabase from '../lib/supabase'

const PORTAL_SESSION_KEY = 'codevaro_portal_session'

export default function ClientPortalLogin() {
  const navigate = useNavigate()

  const [form, setForm] = useState({
    email: '',
    password: ''
  })
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  async function handleSubmit(e) {
    e.preventDefault()

    try {
      setLoading(true)
      setError('')

      const { data, error: rpcError } = await supabase.rpc('codevaro_client_portal_login', {
        p_email: form.email,
        p_password: form.password
      })

      if (rpcError) throw rpcError

      const session = data?.[0]
      if (!session?.session_token) {
        throw new Error('Δεν δημιουργήθηκε session.')
      }

      localStorage.setItem(PORTAL_SESSION_KEY, session.session_token)
      navigate('/portal', { replace: true })
    } catch (err) {
      console.error(err)
      setError(err.message || 'Σφάλμα σύνδεσης.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center px-4">
      <div className="w-full max-w-md rounded-2xl bg-white p-8 shadow-lg">
        <h1 className="text-2xl font-semibold text-gray-900 mb-2">Client Portal</h1>
        <p className="text-sm text-gray-600 mb-6">
          Σύνδεση πελάτη.
        </p>

        {error ? (
          <div className="mb-4 rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-red-700">
            {error}
          </div>
        ) : null}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="mb-1 block text-sm font-medium text-gray-700">Email</label>
            <input
              type="email"
              value={form.email}
              onChange={(e) => setForm((prev) => ({ ...prev, email: e.target.value }))}
              className="w-full rounded-lg border border-gray-300 px-3 py-2"
              required
            />
          </div>

          <div>
            <label className="mb-1 block text-sm font-medium text-gray-700">Κωδικός</label>
            <input
              type="password"
              value={form.password}
              onChange={(e) => setForm((prev) => ({ ...prev, password: e.target.value }))}
              className="w-full rounded-lg border border-gray-300 px-3 py-2"
              required
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full rounded-lg bg-blue-600 px-4 py-2 text-white hover:bg-blue-700 disabled:opacity-50"
          >
            {loading ? 'Σύνδεση...' : 'Σύνδεση'}
          </button>
        </form>
      </div>
    </div>
  )
}